import { Typography } from '@mui/material';

interface ModalSubtitleProps {
  children: React.ReactNode;
}

export const ModalSubtitle = ({ children }: ModalSubtitleProps) => (
  <Typography variant="body2">{children}</Typography>
);
